import type { DriverDeviceEventKind, DriverDeviceEventView } from '@chukua/common';

export const DEVICE_EVENT_LABELS: Record<DriverDeviceEventKind, string> = {
  signed_in: 'Signed in',
  replaced: 'Replaced by another phone',
  signed_out: 'Signed out',
  revoked_by_office: 'Revoked by the office',
  driver_deactivated: 'Ended when the driver was deactivated',
  reuse_detected: 'Signed out after a stolen sign-in was replayed',
  wipe_requested: 'Wipe requested',
  wipe_delivered: 'Wipe sent to the phone',
  wipe_superseded: 'Wipe never reached the phone: the driver signed in on another one',
};

/** "Pixel 7 · app 1.4.0" from what the phone reported at sign-in; empty when it reported nothing. */
export function describeEventDevice(detail: DriverDeviceEventView['detail']): string {
  const parts = [detail.model, detail.appVersion ? `app ${detail.appVersion}` : null].filter((part): part is string => !!part);
  return parts.join(' · ');
}

/** What the phone is called in a toast: its model, else the id the app gave it. */
export function deviceName(device: { model: string | null; deviceId: string }): string {
  return device.model ?? device.deviceId;
}
